import { useEffect, useMemo, useState, useRef, useContext } from "react"
import LeftComp from '../LeftComp'
import MiddleComp from '../MiddleComp'
import RightComp from '../RightComp'
import styles from './index.module.scss'
import { GenerateContext, GenerateContextProvider } from "../hooks/GenerateContext"
import { useLocation, useNavigate } from "react-router-dom"
import eventBus from "@utils/eventBus"
import { RESOURCE_TYPE, IMAGE_TYPE } from "@utils/CONST"
import { AppContext } from '@utils/AppContext'
import FusionWear from '../FusionWear'
import CreativeToImage from '../CreativeToImage'
import API from "@api/api"

const CreativeToImageLayout = ({ content }) => {
    return <div className={styles.Layout}>
        {content}
    </div>
}

const Layout = (props) => {
    const { setGlobalTaskReadFlag } = useContext(AppContext)

    const { imageType } = props
    const [taskInfo, setTaskInfo] = useState()
    const [sendUrlObj, setSendUrlObj] = useState()
    const location = useLocation()
    const navigate = useNavigate();
    const middleRef = useRef()

    const createClick = () => {
        // 触发侧边栏和中间页更新
        setGlobalTaskReadFlag(prev => !prev)
        if (middleRef.current) middleRef.current.fetchProjectDetail()
    }

    const LayoutLeft = useMemo(() => {
        return <LeftComp imageType={imageType} createClick={createClick} />
    }, [imageType])
    const LayoutMiddle = useMemo(() => {
        return <MiddleComp ref={middleRef} imageType={imageType} />
    }, [imageType])
    const LayoutRight = useMemo(() => {
        return <RightComp imageType={imageType} />
    }, [imageType])
    const LayoutFusionWear = useMemo(() => {
        return <FusionWear imageType={imageType} />
    }, [imageType])
    const LayoutCreativeToImage = useMemo(() => {
        return <CreativeToImage imageType={imageType} />
    }, [imageType])

    // 功能串联
    useEffect(() => {
        if (location.state?.taskInfo) {
            const taskInfo = location.state.taskInfo
            setTaskInfo(taskInfo)
            navigate(location.pathname, {
                replace: true,
            })
        } else if (location.state?.url) {
            const { url, target, imageType, silentSelect } = location.state
            setSendUrlObj({
                url,
                target,
                imageType,
                silentSelect,
            })
            navigate(location.pathname, {
                replace: true,
            })
        }
    }, [location])

    useEffect(() => {
        if (!sendUrlObj) return
        const { url, target, imageType, silentSelect } = sendUrlObj
        if (target == "inputImage") {
            if (imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN) {
                eventBus.emit("creativeToImageAutoUpload", url)
            } else {
                eventBus.emit("sendUrlToInputImage", url, imageType)
            }
        } else {
            if (target == RESOURCE_TYPE.TRYON_SHOES ||
                target == RESOURCE_TYPE.GLASSES_TRYON ||
                target == RESOURCE_TYPE.NECKLACE_TRYON ||
                target == RESOURCE_TYPE.TRYON_MODEL ||
                target == RESOURCE_TYPE.SIM_TRYON ||
                target == RESOURCE_TYPE.FLATLAY3D) {
                eventBus.emit("sendUrlToCustomMaterial", {
                    url,
                    resourceType: target,
                    silentSelect,
                })
            } else if (target == RESOURCE_TYPE.FUSIONWEAR_MODEL) {
                eventBus.emit("fusionWearAutoUpload", url)
                
            }
        }
    }, [sendUrlObj])

    return (
        <GenerateContextProvider
            key={location.key}
            imageType={props.imageType}
            taskInfo={taskInfo}
        >
            {
                imageType == IMAGE_TYPE.FUSION_WEAR ? <div className={styles.Layout}>
                    {LayoutFusionWear}
                    {localStorage.getItem('token') && LayoutRight}
                </div> : imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN ? <CreativeToImageLayout content={LayoutCreativeToImage} /> : <div className={styles.Layout}>
                    {LayoutLeft}
                    {LayoutMiddle}
                    {localStorage.getItem('token') && LayoutRight}
                </div>
            }
        </GenerateContextProvider >
    )
}

export default Layout
